/** Where the URLs the app has used before go now. The four old "Me" tab URLs live in bookmarks and notifications, so they redirect to `/me`: `salary` and `settlement` with that popup open (`?open=`), `info` opening the My info popup, the rest to the page. */

const ME_PATH = '/me'

export type MePopup = 'salary' | 'settlement' | 'access' | 'info'

/** `/me` with, optionally, a popup to open on arrival. */
export function mePath(open?: MePopup): string {
  return open ? `${ME_PATH}?open=${open}` : ME_PATH
}

/** Which popup a `?open=` value names, or null for none or anything unknown. */
export function parseMePopup(value: string | null): MePopup | null {
  return value === 'salary' || value === 'settlement' || value === 'access' || value === 'info'
    ? value
    : null
}

/** The current home of a retired Me URL (the four tab pages and `/my-payslips`), or undefined. */
export function legacyMePath(pathname: string): string | undefined {
  const parts = pathname.replace(/\/+$/, '').split('/').filter(Boolean)
  if (parts.length === 1 && parts[0] === 'my-payslips') return mePath('salary')
  if (parts.length !== 2 || parts[0] !== 'me') return undefined
  if (parts[1] === 'salary') return mePath('salary')
  if (parts[1] === 'info') return mePath('info')
  if (parts[1] === 'supervisor' || parts[1] === 'equipment') return ME_PATH
  return undefined
}

/** The current home of a URL the app has used before, or undefined when the path is not one. The caller appends the query string and hash.
 *  `/hr/users` is NOT here: it has its own route to `/admin/users`. `/company/info` goes to `/company-info`, the read-only identities page. */
export function legacyCompanyPath(pathname: string): string | undefined {
  const parts = pathname.replace(/\/+$/, '').split('/').filter(Boolean)
  const [head, ...rest] = parts
  if (head === 'company') {
    if (rest.length === 0) return '/org-chart'
    if (rest.length === 1 && rest[0] === 'org-chart') return '/org-chart'
    if (rest.length === 1 && rest[0] === 'inventory') return '/inventory'
    if (rest.length === 1 && rest[0] === 'info') return '/company-info'
    if (rest[0] === 'hr' && rest.length <= 2) return rest.length === 2 ? `/hr/${rest[1]}` : '/hr'
    return undefined
  }
  if (head !== 'hr') return undefined
  if (rest[0] === 'directory') {
    if (rest.length > 2) return undefined
    return rest.length === 2 ? `/hr/${rest[1]}` : '/hr'
  }
  if (rest[0] === 'org-chart' && rest.length === 1) return '/hr'
  return undefined
}
